import { type MutateOptions, useMutation } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import { handleResponseError } from '@/_utils/services';

interface PostSendEventParams {
  eventName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: any;
}

export const postSendEvent = async ({
  eventName,
  payload,
}: PostSendEventParams) => {
  return apiClient
    .post(`/utils/send-event`, {
      eventName,
      payload,
    })
    .then(response => response.data)
    .catch(
      handleResponseError({
        methodPath: 'POST /utils/send-event',
      }),
    );
};

export const usePostSendEvent = (
  options: Omit<
    MutateOptions<boolean, Error, PostSendEventParams>,
    'mutationFn'
  > = {},
) => {
  return useMutation({
    mutationFn: postSendEvent,
    ...options,
  });
};
